<div
  class='pageContentCommonStyle'
>
  <app-players-page-search
    (changeEmitter)="searchPlayer($event)"
  ></app-players-page-search>
  <app-players-page-table
    [playersList]="getPlayersToDisplay()"
    (clickedHeader)="setClickedHeaderId($event)"
    [isDescendingOrder]="isDescendingOrder()"
    [Order]="chosenOrder"
  >
  </app-players-page-table>
</div>
